module.exports = __webpack_public_path__ + "9a2694f50e625518466fa06122f69043.png";